module.exports = {
  footerText: "Copyright STRACON Technologies © 2026",
};
